import { render, staticRenderFns } from "./DevolucionPorFactura.vue?vue&type=template&id=0165dda1"
import script from "./DevolucionPorFactura.vue?vue&type=script&lang=js"
export * from "./DevolucionPorFactura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports